export default __webpack_public_path__ + "static/media/ToolShare.981c8ac4.png";